import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { SvcRouterOutletComponent } from './apps/svc-router-outlet/svc-router-outlet.component';
import { TranslocoCoreModule } from './features/transloco/transloco.module';
import { AuthInterceptor } from './auth/auth.interceptor';
import { SvcLoadingBarModule } from './apps/svc-loading-bar/svc-loading-bar.module';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { GtmInitializerDirective, GtmTrackClickDirective } from './directives';
import { provideAuthUserChangeListener } from './auth/check-changed-auth-user-and-reload.provider';


@NgModule({
  declarations: [
    SvcRouterOutletComponent,
    GtmInitializerDirective,
    GtmTrackClickDirective,
  ],
  imports: [
    LibSharedCommonModule,
  ],
  exports: [
    TranslocoCoreModule,
    LibSharedCommonModule,
    SvcLoadingBarModule,
    SvcRouterOutletComponent,
    GtmInitializerDirective,
    GtmTrackClickDirective,
  ],
  providers: [
    ...provideAuthUserChangeListener(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: MAT_TABS_CONFIG,
      useValue: { animationDuration: '0ms' }
    },
    provideHttpClient(withInterceptorsFromDi())
  ],
})
export class LibSharedCoreModule {
  /**
 * Constructor
 */
  constructor(
    @Optional() @SkipSelf() parentModule?: LibSharedCoreModule
  ) {
    // Do not allow multiple injections
    if (parentModule) {
      throw new Error('LibSharedCoreModule has already been loaded. Import this module in the AppModule only.');
    }
  }
}